import { useState, useEffect, useCallback, useRef } from 'react';
import apiExtension from './api_extension'; // 复用现有API请求工具
import './VocabularyPractice.css'; // 复用现有样式文件

// 添加问答场景学习专用样式
const qaSceneStyles = `
  /* 问答场景学习容器样式 */
  .vocabulary-practice-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    background-color: #f8f9fa;
    min-height: 100vh;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }
  
  /* 音频提示文本样式 */
  .audio-url-hint {
    margin-left: 8px;
    font-size: 12px;
    color: #666;
    background-color: #f0f0f0;
    padding: 2px 8px;
    border-radius: 12px;
  }
  
  .audio-url-hint.small {
    font-size: 10px;
    padding: 1px 6px;
  }

  /* 头部样式 */
  .header {
    text-align: center;
    margin-bottom: 30px;
  }

  .header h2 {
    color: #2c3e50;
    margin-bottom: 10px;
    font-size: 2.2rem;
    font-weight: 700;
    letter-spacing: -0.5px;
  }

  .header .description {
    color: #7f8c8d;
    font-size: 1.1rem;
  }

  /* 筛选区域样式 */
  .filter-section {
    background-color: white;
    border-radius: 12px;
    padding: 25px;
    margin-bottom: 30px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }

  .filter-group {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .filter-group label {
    color: #555;
    font-weight: 600;
    white-space: nowrap;
  }

  .filter-select {
    padding: 10px 20px;
    border: 1px solid #ddd;
    border-radius: 25px;
    background-color: white;
    font-size: 1rem;
    color: #333;
    cursor: pointer;
    min-width: 220px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23555' viewBox='0 0 16 16'%3E%3Cpath d='M8 12a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5a.5.5 0 0 1-.5.5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 40px;
  }

  .filter-select:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
  }

  /* 问答卡片容器 */
  .qa-card-container {
    background-color: white;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    margin-bottom: 30px;
    min-height: 400px;
    display: flex;
    flex-direction: column;
  }

  /* 问答卡片样式 */
  .qa-card {
    flex: 1;
    position: relative;
  }

  /* 进度指示器 */
  .qa-progress {
    position: absolute;
    top: -20px;
    right: 10px;
    background: linear-gradient(135deg, #3498db, #2980b9);
    color: white;
    padding: 6px 12px;
    border-radius: 18px;
    font-size: 0.9rem;
    font-weight: 500;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  /* 问答区域通用样式 */
  .qa-section {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .qa-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  /* 问答头部 */
  .qa-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .qa-header h3 {
    color: #2c3e50;
    font-size: 1.5rem;
    font-weight: 600;
  }

  /* 操作按钮组 */
  .qa-actions {
    display: flex;
    gap: 8px;
  }

  .action-button {
    padding: 8px 12px;
    border: none;
    background-color: #f8f9fa;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 1.1rem;
    min-width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .action-button:hover:not(:disabled) {
    background-color: #3498db;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);
  }

  .action-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .action-button.playing {
    background-color: #e74c3c;
    color: white;
    animation: pulse 1s infinite;
  }

  .action-button.small {
    padding: 6px 10px;
    font-size: 0.9rem;
    min-width: 32px;
    height: 32px;
  }

  /* 问答内容 */
  .qa-content {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
  }

  .qa-text {
    margin-bottom: 10px;
    line-height: 1.6;
  }

  .qa-text:last-child {
    margin-bottom: 0;
  }

  .english-text {
    font-size: 1.3rem;
    color: #2c3e50;
    font-weight: 500;
  }

  .chinese-text {
    font-size: 1.2rem;
    color: #7f8c8d;
    font-style: italic;
  }

  .chinese-text.small {
    font-size: 1rem;
  }

  /* 备注信息 */
  .qa-remark {
    background-color: #fff;
    padding: 15px;
    border-radius: 6px;
    margin-top: 15px;
    border-left: 4px solid #3498db;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  }

  .qa-remark.small {
    padding: 10px 15px;
    margin-top: 10px;
  }

  .qa-remark p {
    margin: 0;
    color: #555;
    line-height: 1.5;
  }

  /* 答句列表 */
  .answers-list {
    margin-top: 15px;
  }

  .answer-item {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }

  .answer-item:hover {
    background-color: #e9ecef;
    transform: translateX(5px);
  }

  .answer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .answer-actions {
    display: flex;
    gap: 5px;
  }

  .no-answers {
    text-align: center;
    color: #7f8c8d;
    font-style: italic;
    padding: 20px;
  }

  /* 导航控制按钮 */
  .navigation-controls {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-top: 30px;
  }

  .nav-button {
    flex: 1;
    padding: 12px 25px;
    background: linear-gradient(135deg, #3498db, #2980b9);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);
  }

  .nav-button:hover:not(:disabled) {
    background: linear-gradient(135deg, #2980b9, #1f6d9e);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(52, 152, 219, 0.3);
  }

  .nav-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* 空状态 */
  .empty-state {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7f8c8d;
    font-size: 1.2rem;
    text-align: center;
    padding: 50px 20px;
  }

  /* 加载状态 */
  .loading-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #3498db;
    font-size: 1.2rem;
    text-align: center;
    padding: 50px 20px;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 15px;
  }

  /* 错误状态 */
  .error-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #e74c3c;
    font-size: 1.2rem;
    text-align: center;
    padding: 50px 20px;
  }

  .error-message {
    margin-bottom: 20px;
  }

  .retry-button {
    padding: 10px 20px;
    background: linear-gradient(135deg, #e74c3c, #c0392b);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
  }

  .retry-button:hover {
    background: linear-gradient(135deg, #c0392b, #a93226);
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(231, 76, 60, 0.2);
  }

  /* 底部提示 */
  .footer {
    text-align: center;
    margin-top: 20px;
  }

  .hint-text {
    color: #7f8c8d;
    font-size: 0.9rem;
    font-style: italic;
  }

  /* 动画 */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.7; }
    100% { opacity: 1; }
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .vocabulary-practice-container {
      padding: 15px;
      border-radius: 0;
    }

    .header h2 {
      font-size: 1.8rem;
    }

    .filter-section {
      flex-direction: column;
      align-items: stretch;
    }

    .filter-group {
      flex-direction: column;
      align-items: stretch;
    }

    .filter-select {
      min-width: 100%;
    }

    .qa-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    .qa-header h3 {
      font-size: 1.3rem;
    }

    .english-text {
      font-size: 1.2rem;
    }

    .chinese-text {
      font-size: 1.1rem;
    }

    .nav-button {
      padding: 10px 15px;
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    .header h2 {
      font-size: 1.5rem;
    }

    .qa-card-container {
      padding: 15px;
    }

    .answer-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }
`;

// 创建样式标签并添加到文档头部
if (typeof window !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = qaSceneStyles;
  document.head.appendChild(styleElement);
}

// 音频播放工具（增强URL处理和错误提示，修复多按钮状态问题）
const useAudioPlayer = () => {
  const [currentPlayingAudio, setCurrentPlayingAudio] = useState(null); // 使用null或具体ID来跟踪当前播放的音频
  const [audioError, setAudioError] = useState('');
  const audioRef = useRef(null);

  // 音频URL处理函数 - 确保是可播放的绝对路径
  const processAudioUrl = useCallback((url) => {
    if (!url) return null;
    
    // 检查是否已经是完整的URL
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // 如果是相对路径，尝试拼接后端基础URL
    const baseUrl = 'https://www.yangcongstudy.xin'; // 走 nginx 443 反代，勿直连 8000（纯 HTTP 端口）
    return url.startsWith('/') ? baseUrl + url : baseUrl + '/' + url;
  }, []);

  const playAudio = useCallback((audioUrl) => {
    setAudioError(''); // 清除之前的错误
    
    if (!audioUrl) {
      setAudioError('没有可用的音频资源');
      return;
    }
    
    const processedUrl = processAudioUrl(audioUrl);
    if (!processedUrl) {
      setAudioError('音频URL格式不正确');
      return;
    }
    
    // 停止当前播放的音频
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    
    // 播放新音频
    try {
      audioRef.current = new Audio(processedUrl);
      audioRef.current.play()
        .then(() => {
          setCurrentPlayingAudio(processedUrl); // 记录当前播放的音频URL
          console.log(`播放音频: ${processedUrl}`);
        })
        .catch(err => {
          console.error('音频播放失败:', err);
          setCurrentPlayingAudio(null);
          setAudioError(`音频播放失败: ${err.message}`);
        });
      
      // 播放结束回调
      audioRef.current.onended = () => {
        setCurrentPlayingAudio(null);
      };
      
      // 30秒后自动停止（防止无限播放）
      setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.pause();
          setCurrentPlayingAudio(null);
        }
      }, 30000);
    } catch (err) {
      console.error('创建音频对象失败:', err);
      setAudioError(`音频初始化失败: ${err.message}`);
      setCurrentPlayingAudio(null);
    }
  }, [processAudioUrl]);

  // 组件卸载时停止音频
  useEffect(() => {
    return () => {
      if (audioRef.current) audioRef.current.pause();
    };
  }, []);

  // 清除音频错误
  const clearAudioError = useCallback(() => {
    setAudioError('');
  }, []);

  // 判断指定音频是否正在播放
  const isAudioPlaying = useCallback((audioUrl) => {
    if (!audioUrl || !currentPlayingAudio) return false;
    
    const processedUrl = processAudioUrl(audioUrl);
    return processedUrl === currentPlayingAudio;
  }, [currentPlayingAudio, processAudioUrl]);

  return { playAudio, currentPlayingAudio, isAudioPlaying, audioError, clearAudioError };
};

// 多级场景格式化工具（添加数组校验和错误处理）
const formatScenesForSelect = (scenes) => {
  // 先校验scenes是否为数组，不是则返回空
  if (!Array.isArray(scenes)) {
    console.error('错误：场景数据不是数组，当前数据:', scenes);
    return [];
  }
  
  const formatted = [];
  // 先处理一级场景（无父场景）
  const rootScenes = scenes.filter(scene => !scene.parent);
  
  const recursiveFormat = (parentScene, depth = 0) => {
    // 校验parentScene是否为对象（避免无效数据）
    if (typeof parentScene !== 'object' || parentScene === null || !parentScene.id || !parentScene.name) {
      console.warn('跳过无效场景数据:', parentScene);
      return;
    }
    
    const indent = '　'.repeat(depth); // 中文空格，实现层级缩进
    formatted.push({
      id: parentScene.id,
      name: `${indent}${parentScene.name}`, // 显示层级（如“　点餐”表示“餐厅”的子场景）
      rawName: parentScene.name // 原始名称，用于显示
    });
    
    // 校验children是否为数组
    if (Array.isArray(parentScene.children) && parentScene.children.length > 0) {
      parentScene.children.forEach(child => recursiveFormat(child, depth + 1));
    }
  };

  rootScenes.forEach(scene => recursiveFormat(scene));
  return formatted;
};

const QaSceneLearning = () => {
  // 1. 状态管理
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [scenes, setScenes] = useState([]); // 所有场景（原始数据）
  const [formattedScenes, setFormattedScenes] = useState([]); // 格式化后的场景（用于下拉）
  const [questionTypes, setQuestionTypes] = useState([]); // 所有问句类型
  const [qaPairs, setQaPairs] = useState([]); // 筛选后的问答对列表
  const [currentIndex, setCurrentIndex] = useState(0); // 当前浏览的问答对索引

  // 2. 筛选条件状态
  const [selectedSceneId, setSelectedSceneId] = useState(''); // 选中的场景ID
  const [selectedQuestionTypeId, setSelectedQuestionTypeId] = useState(''); // 选中的问句类型ID

  // 3. 当前问答对的交互状态
  const [currentQaState, setCurrentQaState] = useState({
    showAskChinese: false, // 是否显示问句中文
    showAskRemark: false // 是否显示问句备注
  });

  // 4. 音频播放Hook
  const { playAudio, currentPlayingAudio, isAudioPlaying, audioError, clearAudioError } = useAudioPlayer();

  // 5. API请求函数
  // 5.1 获取所有场景（支持多级，添加分页数据处理）
  const fetchScenes = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiExtension.fetchWithAuth('/api/askandquestion/scenes/'); // 后端场景列表接口
      console.log('场景接口响应状态:', response.status);
      const data = await response.json();
      console.log('场景接口返回原始数据:', data); // 关键：打印原始数据
      
      // 关键修复：适配后端分页结构
      const sceneList = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
      
      setScenes(sceneList); // 存储处理后的数组
      const formatted = formatScenesForSelect(sceneList);
      setFormattedScenes(formatted);
      console.log('获取场景成功，共', sceneList.length, '个场景');
    } catch (err) {
      setError(`场景加载失败: ${err.message}`);
      console.error('场景加载错误:', err);
      // 出错时显示空数据
      setScenes([]);
      setFormattedScenes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // 5.2 获取所有问句类型（添加数据格式校验和日志）
  const fetchQuestionTypes = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiExtension.fetchWithAuth('/api/askandquestion/question-types/'); // 后端问句类型接口
      console.log('问句类型接口响应状态:', response.status); // 打印状态码
      const data = await response.json();
      console.log('问句类型接口返回原始数据:', data); // 关键：打印原始数据
      
      // 检查data是否为数组，不是则进行相应处理
      let questionTypeList = [];
      if (!data) {
        // 情况1：data为null或undefined
        console.warn('问句类型数据为空，使用空数组');
        questionTypeList = [];
      } else if (Array.isArray(data)) {
        // 情况2：data是数组（正常情况）
        questionTypeList = data;
      } else if (typeof data === 'object' && data.results) {
        // 情况3：data是分页结构对象（包含results数组）
        console.log('检测到分页结构，使用data.results');
        questionTypeList = Array.isArray(data.results) ? data.results : [];
      } else if (typeof data === 'object') {
        // 情况4：data是单个对象
        console.warn('问句类型返回单个对象，转为数组');
        questionTypeList = [data];
      }
      
      // 增加“全部”选项
      setQuestionTypes([{ id: '', name: '全部问句类型' }, ...questionTypeList]);
      console.log('获取问句类型成功，共', questionTypeList.length, '个类型');
    } catch (err) {
      setError(`问句类型加载失败: ${err.message}`);
      console.error('问句类型加载错误:', err);
      // 出错时显示“全部”选项
      setQuestionTypes([{ id: '', name: '全部问句类型' }]);
    } finally {
      setLoading(false);
    }
  }, []);

  // 获取单个问答对的完整数据（包含答句和问句详情）
  const fetchQaPairWithDetails = useCallback(async (qaPairId) => {
    try {
      // 使用正确的API端点获取完整的问答对数据
      const response = await apiExtension.fetchWithAuth(`/api/askandquestion/qa-pairs/${qaPairId}/`);
      console.log(`获取问答对 ${qaPairId} 的完整数据，响应状态:`, response.status);
      
      if (!response.ok) {
        throw new Error(`获取问答对数据失败: ${response.status}`);
      }
      
      const data = await response.json();
      console.log(`问答对 ${qaPairId} 的完整数据:`, data);
      
      // 处理答句数据
      let answers = [];
      if (data.answers && Array.isArray(data.answers)) {
        answers = data.answers.map(answer => ({
          ...answer,
          answer_pronunciation: answer.answer_pronunciation_url || answer.answer_pronunciation || ''
        }));
      }
      
      // 记录问句备注信息到控制台，帮助调试
      console.log(`问答对 ${qaPairId} 的问句备注信息:`, {
        ask_remark: data.ask_remark,
        has_ask_remark: data.hasOwnProperty('ask_remark'),
        is_html: data.ask_remark ? (data.ask_remark.includes('<') || data.ask_remark.includes('>')) : false
      });
      
      // 返回包含答句和问句详情的对象
      return {
        answers,
        ask_remark: data.ask_remark || ''
      };
    } catch (err) {
      console.error(`获取问答对 ${qaPairId} 的详细数据失败:`, err);
      return {
        answers: [],
        ask_remark: ''
      };
    }
  }, []);

  // 5.3 根据筛选条件获取问答对（增强数据格式处理，特别针对问句、答句、音频和备注）
  const fetchQaPairs = useCallback(async () => {
    if (!selectedSceneId) {
      setQaPairs([]);
      setCurrentIndex(0);
      return; // 未选场景时清空问答对
    }

    setLoading(true);
    setError('');
    try {
      // 构建查询参数
      const params = new URLSearchParams();
      params.append('scene', selectedSceneId); // 场景ID筛选
      if (selectedQuestionTypeId) params.append('question_type', selectedQuestionTypeId); // 问句类型筛选（可选）
      params.append('page_size', 1000); // 加载足够多的问答对

      const response = await apiExtension.fetchWithAuth(`/api/askandquestion/qa-pairs/?${params.toString()}`); // 后端问答对接口
      console.log('问答对接口响应状态:', response.status);
      const data = await response.json();
      console.log('问答对接口返回原始数据:', data);
      
      // 增强的分页数据处理
      let qaPairList = [];
      if (!data) {
        qaPairList = [];
      } else if (Array.isArray(data.results)) {
        qaPairList = data.results;
        console.log('检测到分页结构，使用data.results');
      } else if (Array.isArray(data)) {
        qaPairList = data;
      } else if (typeof data === 'object') {
        // 处理可能的特殊情况
        console.warn('问答对数据不是标准格式，尝试提取有用数据');
        qaPairList = [];
      }
      
      // 增强数据处理：适配models.py中定义的字段结构和API实际返回格式
      const processedQaPairs = qaPairList.map(pair => {
        // 从模型和API分析：
        // 1. 问句音频字段在API中是ask_pronunciation_url
        // 2. 确保所有核心字段都有默认值
        
        // 打印字段检查日志
        console.log('问句字段检查:', {
          ask_remark: pair.ask_remark,
          has_ask_remark: pair.hasOwnProperty('ask_remark'),
          other_remark_fields: Object.keys(pair).filter(key => key.includes('remark'))
        });
        
        // 处理问句音频字段映射
        const askPronunciation = pair.ask_pronunciation_url || pair.ask_pronunciation || '';
        
        // 处理核心字段默认值，特别增强ask_remark的处理
        let askRemark = '';
        if (pair.hasOwnProperty('ask_remark')) {
          askRemark = pair.ask_remark || '';
        } else if (pair.hasOwnProperty('remark')) {
          // 兼容可能的其他命名方式
          askRemark = pair.remark || '';
          console.log('使用备用remark字段:', askRemark);
        }
        
        return {
          ...pair,
          // 确保问句核心字段都有默认值
          ask_english: pair.ask_english || '暂无英文问句',
          ask_chinese: pair.ask_chinese || '暂无中文翻译',
          ask_pronunciation: askPronunciation, // 使用处理后的音频URL
          ask_remark: askRemark, // 使用增强处理后的备注
          // 初始化空的answers数组，后续会通过专门的API获取
          answers: []
        };
      });
      
      setQaPairs(processedQaPairs);
      setCurrentIndex(processedQaPairs.length > 0 ? 0 : -1); // 重置到第一个问答对
      console.log('获取问答对成功，共', processedQaPairs.length, '个');
      
      // 如果有问答对，获取第一个问答对的完整数据（包含答句和问句详情）
      if (processedQaPairs.length > 0) {
        const firstQaPair = processedQaPairs[0];
        const detailedResponse = await apiExtension.fetchWithAuth(`/api/askandquestion/qa-pairs/${firstQaPair.id}/`);
        
        if (detailedResponse.ok) {
          const detailedData = await detailedResponse.json();
          console.log(`获取第一个问答对 ${firstQaPair.id} 的完整详细数据:`, detailedData);
          
          // 处理答句数据
          let answers = [];
          if (detailedData.answers && Array.isArray(detailedData.answers)) {
            answers = detailedData.answers.map(answer => ({
              ...answer,
              answer_pronunciation: answer.answer_pronunciation_url || answer.answer_pronunciation || ''
            }));
          }
          
          // 更新问答对数据，同时包含问句备注信息
          setQaPairs(prev => prev.map(pair => 
            pair.id === firstQaPair.id ? {
              ...pair,
              answers,
              // 确保更新问句备注信息
              ask_remark: detailedData.ask_remark || pair.ask_remark || ''
            } : pair
          ));
        } else {
          console.error(`获取第一个问答对 ${firstQaPair.id} 的详细数据失败`);
        }
      }
    } catch (err) {
      setError(`问答对加载失败: ${err.message}`);
      setQaPairs([]);
      setCurrentIndex(-1);
      console.error('问答对加载错误:', err);
    } finally {
      setLoading(false);
    }
  }, [selectedSceneId, selectedQuestionTypeId]);

  // 6. 初始化加载：获取场景和问句类型
  useEffect(() => {
    fetchScenes();
    fetchQuestionTypes();
  }, [fetchScenes, fetchQuestionTypes]);

  // 7. 筛选条件变化时重新加载问答对
  useEffect(() => {
    // 延迟加载，避免频繁请求（用户快速切换下拉时）
    const timer = setTimeout(() => {
      fetchQaPairs();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchQaPairs]);

  // 8. 浏览控制函数（上一个/下一个）
  const handlePrevQa = useCallback(() => {
    if (qaPairs.length === 0) return;
    const newIndex = currentIndex <= 0 ? qaPairs.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    
    // 重置当前问答对的交互状态
    setCurrentQaState({
      showAskChinese: false,
      showAskRemark: false
    });
    
    // 获取新问答对的完整数据（包含答句和问句详情）
    const newQaPair = qaPairs[newIndex];
    if (newQaPair) {
      fetchQaPairWithDetails(newQaPair.id).then(details => {
        setQaPairs(prev => prev.map(pair => 
          pair.id === newQaPair.id ? {
            ...pair,
            answers: details.answers,
            // 确保更新问句备注信息
            ask_remark: details.ask_remark || pair.ask_remark || ''
          } : pair
        ));
      });
    }
  }, [qaPairs, currentIndex, fetchQaPairWithDetails]);

  const handleNextQa = useCallback(() => {
    if (qaPairs.length === 0) return;
    const newIndex = currentIndex >= qaPairs.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    
    // 重置当前问答对的交互状态
    setCurrentQaState({
      showAskChinese: false,
      showAskRemark: false
    });
    
    // 获取新问答对的完整数据（包含答句和问句详情）
    const newQaPair = qaPairs[newIndex];
    if (newQaPair) {
      fetchQaPairWithDetails(newQaPair.id).then(details => {
        setQaPairs(prev => prev.map(pair => 
          pair.id === newQaPair.id ? {
            ...pair,
            answers: details.answers,
            // 确保更新问句备注信息
            ask_remark: details.ask_remark || pair.ask_remark || ''
          } : pair
        ));
      });
    }
  }, [qaPairs, currentIndex, fetchQaPairWithDetails]);

  // 9. 交互控制函数（切换中文显示/备注显示）
  const toggleAskChinese = useCallback(() => {
    setCurrentQaState(prev => ({
      ...prev,
      showAskChinese: !prev.showAskChinese
    }));
  }, []);

  const toggleAskRemark = useCallback(() => {
    setCurrentQaState(prev => ({
      ...prev,
      showAskRemark: !prev.showAskRemark
    }));
  }, []);

  // 10. 获取当前问答对
  const currentQaPair = qaPairs[currentIndex];

  // 11. 重置所有状态（用于重新选择场景时）
  const resetState = useCallback(() => {
    setSelectedQuestionTypeId('');
    setQaPairs([]);
    setCurrentIndex(0);
    setCurrentQaState({
      showAskChinese: false,
      showAskRemark: false
    });
  }, []);

  // 12. 场景选择变化时重置状态
  useEffect(() => {
    resetState();
  }, [selectedSceneId, resetState]);

  // 13. 渲染加载状态
  if (loading && (!scenes.length || !questionTypes.length)) {
    return (
      <div className="vocabulary-practice-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>加载场景和问句类型中...</p>
        </div>
      </div>
    );
  }

  // 14. 渲染错误状态
  if (error) {
    return (
      <div className="vocabulary-practice-container">
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={() => {
            setError('');
            fetchScenes();
            fetchQuestionTypes();
            if (selectedSceneId) fetchQaPairs();
          }}>
            重试
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="vocabulary-practice-container">
      <div className="header">
        <h2>场景化问答学习</h2>
        <p className="description">通过真实场景问答，提升英语会话能力</p>
      </div>

      {/* 筛选条件区域 */}
      <div className="filter-section">
        <div className="filter-group">
          <label htmlFor="scene-select">选择场景：</label>
          <select
            id="scene-select"
            value={selectedSceneId}
            onChange={(e) => setSelectedSceneId(e.target.value)}
            disabled={loading}
            className="filter-select"
          >
            <option value="">-- 请选择场景 --</option>
            {formattedScenes.map(scene => (
              <option key={scene.id} value={scene.id}>
                {scene.name}
              </option>
            ))}
          </select>
        </div>

        {selectedSceneId && (
          <div className="filter-group">
            <label htmlFor="question-type-select">问句类型：</label>
            <select
              id="question-type-select"
              value={selectedQuestionTypeId}
              onChange={(e) => setSelectedQuestionTypeId(e.target.value)}
              disabled={loading}
              className="filter-select"
            >
              {questionTypes.map(type => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* 问答卡片区域 */}
      <div className="qa-card-container">
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>加载问答数据中...</p>
          </div>
        ) : qaPairs.length === 0 ? (
          <div className="empty-state">
            <p>请选择场景和问句类型查看问答内容</p>
          </div>
        ) : currentIndex >= 0 && currentIndex < qaPairs.length ? (
          <>
            {/* 问答卡片 */}
            <div className="qa-card">
              {/* 当前进度 */}
              <div className="qa-progress">
                <span>{currentIndex + 1} / {qaPairs.length}</span>
              </div>

              {/* 问句部分 */}
              <div className="qa-section question-section">
                <div className="qa-header">
                  <h3>问句</h3>
                  <div className="qa-actions">
                    <button
                    className={`action-button ${isAudioPlaying(currentQaPair.ask_pronunciation) ? 'playing' : ''}`}
                    onClick={() => playAudio(currentQaPair.ask_pronunciation)}
                    disabled={!currentQaPair.ask_pronunciation || !!currentPlayingAudio}
                    title="播放发音"
                  >
                    🎵
                  </button>
                  <span className="audio-url-hint">{currentQaPair.ask_pronunciation ? '有音频' : '无音频'}</span>
                    <button
                      className="action-button"
                      onClick={toggleAskChinese}
                      title={currentQaState.showAskChinese ? '隐藏中文' : '显示中文'}
                    >
                      {currentQaState.showAskChinese ? '🇨🇳' : '🇬🇧'}
                    </button>
                    <button
                      className="action-button"
                      onClick={toggleAskRemark}
                      title={currentQaState.showAskRemark ? '隐藏备注' : '显示备注'}
                    >
                      💬
                    </button>
                  </div>
                </div>
                <div className="qa-content">
                  <div className="qa-text english-text">
                    {currentQaPair.ask_english || '暂无英语问句'}
                  </div>
                  {currentQaState.showAskChinese && (
                    <div className="qa-text chinese-text">
                      {currentQaPair.ask_chinese || '暂无中文翻译'}
                    </div>
                  )}
                  {/* 增强的问句备注显示逻辑 - 正确解析HTML格式的备注 */}
                  <div style={{display: currentQaState.showAskRemark ? 'block' : 'none'}}>
                    <div className="qa-remark">
                      <p><strong>备注：</strong>
                        {/* 修复HTML格式备注的显示问题 */}
                        {currentQaPair.ask_remark && currentQaPair.ask_remark.trim() && (currentQaPair.ask_remark.includes('<') || currentQaPair.ask_remark.includes('>')) ? (
                          <span dangerouslySetInnerHTML={{ __html: currentQaPair.ask_remark }} />
                        ) : (
                          currentQaPair.ask_remark || '暂无备注信息'
                        )}
                      </p>
                      {/* 添加调试信息，帮助排查问题 */}
                      <p style={{fontSize: '0.8rem', color: '#666', marginTop: '5px'}}>
                        备注状态: {currentQaState.showAskRemark ? '显示' : '隐藏'} | 
                        备注长度: {currentQaPair.ask_remark ? currentQaPair.ask_remark.length : 0} |
                        包含HTML: {currentQaPair.ask_remark ? (currentQaPair.ask_remark.includes('<') || currentQaPair.ask_remark.includes('>')) : false}
                      </p>
                      {/* 显示原始备注内容的调试信息 */}
                      {currentQaPair.ask_remark && (
                        <div style={{fontSize: '0.75rem', color: '#999', marginTop: '5px', padding: '5px', backgroundColor: '#f5f5f5', borderRadius: '4px', wordBreak: 'break-all'}}>
                          <p><strong>原始备注内容：</strong></p>
                          <p>{currentQaPair.ask_remark}</p>
                        </div>
                      )}
                    </div>
                  </div>
                  {audioError && (
                    <div className="qa-remark" style={{borderLeftColor: '#e74c3c', color: '#e74c3c'}}>
                      <p><strong>音频错误：</strong>{audioError}</p>
                      <button className="action-button small" onClick={clearAudioError} style={{marginTop: '10px'}}>
                        关闭提示
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* 答句部分 */}
              <div className="qa-section answer-section">
                <div className="qa-header">
                  <h3>答句 ({currentQaPair.answers?.length || 0})</h3>
                </div>
                <div className="answers-list">
                  {Array.isArray(currentQaPair.answers) && currentQaPair.answers.length > 0 ? (
                    currentQaPair.answers.map((answer, index) => {
                      // 确保answer是对象
                      const validAnswer = typeof answer === 'object' && answer !== null ? answer : {};
                       
                      return (
                        <div key={validAnswer.id || index} className="answer-item">
                          <div className="answer-content">
                            <div className="qa-text english-text">
                              {validAnswer.answer_english || '暂无英语答句'}
                            </div>
                            <div className="qa-actions answer-actions">
                              <button
                          className={`action-button small ${isAudioPlaying(validAnswer.answer_pronunciation) ? 'playing' : ''}`}
                          onClick={() => playAudio(validAnswer.answer_pronunciation)}
                          disabled={!validAnswer.answer_pronunciation || !!currentPlayingAudio}
                          title="播放发音"
                        >
                          🎵
                        </button>
                        <span className="audio-url-hint small">{validAnswer.answer_pronunciation ? '有音频' : '无音频'}</span>
                            </div>
                          </div>
                          {validAnswer.answer_chinese && (
                            <div className="qa-text chinese-text small">
                              {validAnswer.answer_chinese}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="no-answers">暂无答句</p>
                  )}
                </div>
              </div>
            </div>

            {/* 浏览控制按钮 */}
            <div className="navigation-controls">
              <button className="nav-button" onClick={handlePrevQa} disabled={loading}>
                上一个
              </button>
              <button className="nav-button" onClick={handleNextQa} disabled={loading}>
                下一个
              </button>
            </div>
          </>
        ) : (
          <div className="empty-state">
            <p>没有找到匹配的问答内容</p>
          </div>
        )}
      </div>

      {/* 底部信息 */}
      <div className="footer">
        <p className="hint-text">提示：点击发音按钮播放语音，点击语言按钮切换中英文显示，点击问句备注按钮查看详细说明</p>
      </div>
    </div>
  );
};

export default QaSceneLearning;